import httpService from "./httpService";
import utils from "./utils";

export default {
  hieuChinhVanBan(form) {
    return httpService.post("/outgoingDoc/hieuChinhVanBan", form);
  },

  updateTltvbData(id, form) {
    return httpService.post(`/outgoingDoc/${id}/updateTltvbData`, form);
  },

  suaSaiBanHanh(id, form) {
    return httpService.put(`/outgoingDoc/${id}/suaSaiBanHanh`, form);
  },

  createOutgoingDoc(form) {
    return httpService.post("/outgoingDoc/createOutgoingDoc", form);
  },

  uploadFildRelation(data) {
    return httpService.post("/outgoingDoc/updateOutgoingDocRelation", data);
  },

  createOutgoingDocKyNgoai(form) {
    return httpService.post("/outgoingDoc/createOutgoingDocKyNgoai", form);
  },

  count(usingAdvanceSearch, keyword, form) {
    let params = utils.merge(
      { usingAdvanceSearch: usingAdvanceSearch, keyword: keyword },
      form
    );

    return httpService.get("/outgoingDoc/count", { params: params });
  },

  search(query) {
    return httpService.get("/outgoingDoc/search", {
      params: {
        query: query
      }
    });
  },

  findById(id) {
    return httpService.get(`/outgoingDoc/${id}`);
  },

  maskAsRead(id, processId) {
    let params = { docId: id, processId: processId };
    return httpService.post(`/outgoingDoc/maskAsRead`, null, {
      params: params
    });
  },

  listChoBanHanh2(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get("/outgoingDoc/listChoBanHanh", { params: params });
  },

  banHanhVanBan(form) {
    return httpService.post("/outgoingDoc/banHanhVanBan", form);
  },

  ccVanBan(form) {
    return httpService.post("/outgoingDoc/ccVanBan", form);
  },

  thuHoi(id, form) {
    return httpService.put(`/outgoingDoc/${id}/thuHoi`, form);
  },

  thuHoiBanHanh(id, form) {
    return httpService.put(`/vbOutgoingProcess/${id}/thuHoiBanHanh`, form);
  },

  thuHoiCC(id, form) {
    return httpService.post("/outgoingDoc/thuHoiCC", { docId: id, ...form });
  },

  delete(id) {
    return httpService.delete(`/outgoingDoc/${id}`);
  },

  deleteForVanThu(id) {
    return httpService.delete(`/outgoingDoc/deleteForVanThu/${id}`);
  },

  findAllForHcCommandsDocRelation(deptId, keyword, pageable) {
    let params = utils.merge(
      { deptId: deptId, keyword: keyword },
      utils.initPageableParams(pageable)
    );
    return httpService.get("/outgoingDoc/findAllForHcCommandsDocRelation", {
      params: params
    });
  },

  permanentDelete(id) {
    return httpService.delete(`/outgoingDoc/permanentDelete/${id}`);
  },

  restore(id) {
    return httpService.put(`/outgoingDoc/restore/${id}`);
  },

  findAllByAchievement(form, pageable) {
    let params = utils.merge(form, utils.initPageableParams(pageable));
    return httpService.get("/outgoingDoc/findAllByAchievement", {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/outgoingDocService.js